document.addEventListener("DOMContentLoaded", function() {
    const elements = document.querySelectorAll('.image-link-blocks__title');
    let maxHeight = 0;

    // Find the maximum height
    elements.forEach(el => {
        const height = el.offsetHeight;
        if (height > maxHeight) {
            maxHeight = height;
        }
    });

    // Set all elements to the maximum height
    elements.forEach(el => {
        el.style.height = `${maxHeight}px`;
    });
});
$.get("https://ipinfo.io", function(response) {    
  if(response.country != "IN"){
    window.location.href = "https://www.ascentmeditech.com/request-for-business-deal/";
  }
}, "jsonp");